import { useQuery } from "@tanstack/react-query";
import { apisiseci } from "../../api";
import { UserList } from "../../../@types/users";

export function useGetUser(id: string) {
  const token = localStorage.getItem("gov_access_token_sso");

  return useQuery<UserList>({
    queryKey: ["profile", "details", id],
    queryFn: async () => {
      const response = await apisiseci.get<UserList>(`/cms/user_list/${id}/`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    },
  });
}
